﻿import React, { useContext, useMemo } from 'react';
import Context, { context_type } from '@Util/Context';
import { Icon_Timer } from '@Elements/ImageElements/Icons';
import { P } from '@Elements/Fonts';
import { str_isEmpty } from '@Util/Utils';
import { Tooltip } from 'react-tooltip';
import Customer_Name_With_Color from '@Elements/Table/Customer_Name_With_Color';

const Current_Project_Ellapsed_Time: React.FC = () => {
    const { current_project, current_project_ellapsed_time }: context_type = useContext(Context);

    const tooltipHtml: string = useMemo(() => {
        return `
            <span class="Desktop">${current_project_ellapsed_time.simple}h</span>
            <span class="Mobile">${current_project.customerName} - ${current_project.projectName}</span>
        `;
    }, [current_project_ellapsed_time.simple, current_project.customerName, current_project.projectName]);

    return (
        <div className="Dynamic_Island_Ellapsed_Time">
            <Icon_Timer />
            {!str_isEmpty(current_project_ellapsed_time.humanized) && (
                <P secondary={true}>
                    <a
                        data-tooltip-id="current_project_ellapsed_time_tooltip"
                        data-tooltip-html={tooltipHtml}
                        data-tooltip-place="top"
                    >
                        <span className="Desktop">{current_project_ellapsed_time.humanized}</span>
                        <span className="Mobile">
                            {current_project.customerName && current_project.projectName && (
                                <Customer_Name_With_Color 
                                    name=""
                                    color={current_project.color}
                                />
                            )}
                            {`${current_project_ellapsed_time.simple}h`}
                        </span>
                    </a>
                    <Tooltip id="current_project_ellapsed_time_tooltip" />
                </P>
            )}
            {current_project.customerName && current_project.projectName && (
                <P bold={true}>
                    <span className="Desktop">{`${current_project.customerName} - ${current_project.projectName}`}</span>
                </P>
            )}
        </div>
    );
};

export default React.memo(Current_Project_Ellapsed_Time);